"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _AudienceTargetingRenderer = _interopRequireDefault(require("AudienceTargetingUIComponents/AudienceTargetingRenderer"));

var _serializer = require("AudienceTargetingUIComponents/utils/serializer");

var _validationUtils = require("AudienceTargetingUIComponents/utils/validationUtils");

var _scopes = require("AudienceTargetingUIComponents/utils/scopes");

var _Filters = require("AudienceTargetingUIComponents/constants/Filters");

var _Scopes = require("AudienceTargetingUIComponents/constants/Scopes");

var AudienceTargetingComponent =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(AudienceTargetingComponent, _Component);
  (0, _createClass2.default)(AudienceTargetingComponent, null, [{
    key: "propTypes",
    get: function get() {
      return {
        audience: _react.PropTypes.object,
        // audience targeting object coming from the server (can be null)
        filterList: _react.PropTypes.arrayOf( // eslint-disable-next-line consistent-return
        function (propValue, idx, componentName, location, propFullName) {
          if (!_Filters.FILTERS[propValue[idx]]) {
            return new Error("Invalid prop '" + propFullName + "' supplied to '" + componentName + "'. Validation failed.");
          }
        }).isRequired,
        // whitelist of filters
        labelConfig: _react.PropTypes.object.isRequired,
        // config object with strings for the labels
        onChange: _react.PropTypes.func.isRequired,
        // event handler for the app where this library will live
        onValidationError: _react.PropTypes.func,
        // event handler for when validation errors happen
        scopes: _react.PropTypes.array.isRequired,
        // to check for audience-targeting-advanced-rules scope
        upgradeConfig: _react.PropTypes.object.isRequired,
        // data to config upgrade modal
        usageTracking: _react.PropTypes.func // event handler for tracking user interaction

      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        labelConfig: {},
        onValidationError: function onValidationError() {},
        scopes: []
      };
    }
  }]);

  function AudienceTargetingComponent(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AudienceTargetingComponent);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AudienceTargetingComponent).call(this, props));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.validate = _this.validate.bind((0, _assertThisInitialized2.default)(_this));
    _this.updateAudience = _this.updateAudience.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      audience: (0, _serializer.serializeAudience)(props.audience),
      validationErrors: []
    };
    return _this;
  }

  (0, _createClass2.default)(AudienceTargetingComponent, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var audience = this.state.audience;
      var audienceCopy = (0, _extends2.default)({}, audience);
      var newAudience = (0, _serializer.normalizeAudience)(audienceCopy);
      this.props.onChange(newAudience);
    }
  }, {
    key: "handleChange",
    value: function handleChange() {
      var _this$props = this.props,
          onValidationError = _this$props.onValidationError,
          usageTracking = _this$props.usageTracking; // we make sure we validate before triggering the external event handler

      if (usageTracking) usageTracking('audience-targeting-edited-filters');
      this.validate(onValidationError);
    }
  }, {
    key: "updateAudience",
    value: function updateAudience(newAudience) {
      var _this2 = this;

      var isType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var addsGroup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (!isType) {
        this.validate(function (validationErrors) {
          _this2.setState({
            audience: newAudience
          }, function () {
            if (!validationErrors.length && !addsGroup) {
              _this2.props.onChange((0, _serializer.normalizeAudience)(newAudience));
            }

            _this2.props.onValidationError(validationErrors);
          });
        });
      } else {
        this.setState({
          audience: newAudience
        });
      }
    }
  }, {
    key: "validate",
    value: function validate() {
      var _this3 = this;

      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      var audience = this.state.audience;
      if (!audience) return;
      var errors = (0, _validationUtils.validateAudienceTargeting)(audience);
      this.setState({
        validationErrors: errors || []
      }, function () {
        // callback is the onValidationError handler provided by the app
        callback(_this3.state.validationErrors);
      });
    }
  }, {
    key: "renderExplanation",
    value: function renderExplanation() {
      var labelConfig = this.props.labelConfig;
      var explanation = labelConfig && labelConfig.explanation;
      if (!labelConfig || !explanation) return null;
      return _react.default.createElement("p", {
        className: "audience-targeting-ui-explanation"
      }, explanation);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          filterList = _this$props2.filterList,
          labelConfig = _this$props2.labelConfig,
          scopes = _this$props2.scopes,
          upgradeConfig = _this$props2.upgradeConfig,
          usageTracking = _this$props2.usageTracking;
      var audience = this.state.audience;
      return _react.default.createElement("div", {
        className: "audience-targeting-ui-component"
      }, this.renderExplanation(), _react.default.createElement(_AudienceTargetingRenderer.default, {
        audience: audience,
        filterList: filterList,
        handleChange: this.handleChange,
        hasScope: (0, _scopes.hasScope)(scopes, _Scopes.AUDIENCE_TARGETING_ADVANCED_RULES),
        labelConfig: labelConfig,
        upgradeConfig: upgradeConfig,
        updateAudience: this.updateAudience,
        usageTracking: usageTracking
      }));
    }
  }]);
  return AudienceTargetingComponent;
}(_react.Component);

exports.default = AudienceTargetingComponent;
module.exports = exports.default;